import { freeBallOffered, freeBallValue, type ScoreState } from '@aiscoreboard/contracts';
import { useT } from '../lib/i18n';

interface Props {
  state: ScoreState;
  disabled: boolean;
  onFreeBall: (awarded: boolean) => void;
  onBack: () => void;
}

export function FoulFollowUp({ state, disabled, onFreeBall, onBack }: Props) {
  const t = useT();
  if (!freeBallOffered(state)) return null;
  return (
    <div data-foul-followup className="grid w-full grid-cols-2 gap-2">
      <button type="button" disabled={disabled} aria-pressed={state.freeBall}
        title={state.freeBall && state.target !== 'color'
          ? t('match.freeBallWorth', { n: freeBallValue(state, 'black') })
          : t('match.freeBallArmed')}
        onClick={() => onFreeBall(!state.freeBall)}
        className={`min-h-11 rounded-2xl px-2 py-1 text-xs font-bold leading-4 text-sys-yellow ring-2 ring-inset
          ${state.freeBall ? 'bg-sys-yellow/22 ring-sys-yellow/80' : 'bg-sys-yellow/16 ring-sys-yellow/70'}`}>
        {t('match.freeBall')}
      </button>
      <button type="button" disabled={disabled} onClick={onBack}
        title={t('match.foulBackHint', { name: state.players[state.activePlayer === 0 ? 1 : 0] })}
        className="min-h-11 rounded-2xl bg-white/10 px-2 py-1 text-xs font-bold leading-4 text-white/85 ring-1 ring-inset ring-white/20">
        {t('common.back')}
      </button>
    </div>
  );
}
